import {styled} from '@linaria/react';
import React from 'react';
import {BadgeListSmall} from '../../../molecules/BadgeList/BadgeList';

export interface Badge {
  label: string;
  textColor?: string;
  backgroundColor?: string;
}

interface LinkBadgesProps {
  badges: Badge[];
}

export const LinkBadges: React.FC<LinkBadgesProps> = ({badges}) => {
  if (!badges.length) {
    return null;
  }

  return (
    <StyledBadgeListSmall
      disableRoundedCorners={false}
      entries={badges.map(badge => ({
        kind: 'GENERIC',
        ...badge,
      }))}
    />
  );
};

const StyledBadgeListSmall = styled(BadgeListSmall)`
  display: inline-block;
  margin: -1px 0 0 6px;
`;
